var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8838 11.5346C19.7729 10.7843 19.1778 10.1993 18.4118 10.0249C15.4342 9.34538 14.6878 7.67588 14.5619 5.82413C14.0339 5.7285 13.0945 5.625 11.5 5.625C9.90552 5.625 8.96616 5.7285 8.43813 5.82413C8.31218 7.67588 7.56578 9.34538 4.58824 10.0249C3.82219 10.2004 3.22715 10.7843 3.11623 11.5346L2.54198 15.4069C2.33978 16.7704 3.36811 18 4.79853 18H18.2015C19.6308 18 20.6602 16.7704 20.458 15.4069L19.8838 11.5346ZM11.5 15.1785C9.88819 15.1785 8.5814 13.9185 8.5814 12.366C8.5814 10.8135 9.88819 9.5535 11.5 9.5535C13.1118 9.5535 14.4186 10.8135 14.4186 12.366C14.4186 13.9185 13.1107 15.1785 11.5 15.1785ZM22.9965 4.5C22.9688 2.8125 18.5574 0.001125 11.5 0C4.4415 0.001125 0.0300776 2.8125 0.00350278 4.5C-0.0230721 6.1875 0.0277669 8.3835 2.93251 8.01788C6.33063 7.58925 6.12149 6.43388 6.12149 4.78238C6.12149 3.63038 8.88528 3.3525 11.5 3.3525C14.1147 3.3525 16.8774 3.63038 16.8785 4.78238C16.8785 6.43388 16.6694 7.58925 20.0675 8.01788C22.9711 8.3835 23.0231 6.1875 22.9965 4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/PhoneIcon.d272d832b5d3b60f1b8b51eaa210feaf.svg";
export { ForwardRef as ReactComponent };